// extracted by css-extract-rspack-plugin
export default {"buttonWrapper":"_e9cdeb8f","button":"_ebfc9a1c"};